import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import AddButton from '../../../componente/cadastro/botaoadd/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { usePermissoes } from "../../../componente/permissoes";

Modal.setAppElement("#root");

const CadCliente = () => {
    const { podeInserir, podeEditar, podeExcluir } = usePermissoes();

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showform, setshowform] = useState(false);
    const { accessKey, codassinante, codempresa, codusuario } = useAppContext(); // Acessa os dados do contexto          
    const [novo, setnovo] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const columns = [
        { key: 'codcliente', title: 'Código' },
        { key: 'nome', title: 'Nome' },
        { key: 'documento', title: 'Documento' },
        { key: 'cidade', title: 'Cidade' },
        { key: 'bairro', title: 'Bairro' },
        { key: 'telefone', title: 'Telefone' },
        { key: 'whatsapp', title: 'WhatsApp' },
    ];

    //campos
    const [codcliente, setCodCliente] = useState(0);
    const [tipocliente, setTipoCliente] = useState("");
    const [nome, setNome] = useState("");
    const [cpf, setCPF] = useState("");
    const [razaosocial, setRazaoSocial] = useState("");
    const [nomefantasia, setNomeFantasia] = useState("");
    const [cnpj, setCNPJ] = useState("");
    const [ie, setIE] = useState("");
    const [cep, setCEP] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [uf, setUF] = useState("");
    const [codcidade, setCodCidade] = useState("");
    const [pais, setPais] = useState("");
    const [codpais, setCodPais] = useState("");
    const [telefone, setTelefone] = useState("");
    const [whatsapp, setWhatsApp] = useState("");
    const [email, setEmail] = useState("");

    const handleOpen = (cad) => {
        setCodCliente(cad.codcliente);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleDelete();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/cliente", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante,
                    codempresa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

        // Cleanup function para limpar o timeout anterior
        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage, codempresa]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const handleEdit = async (user) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/clienteum", {
                params: {
                    codcliente: user.codcliente
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowform(true);
            setnovo(false);

            setCodCliente(user.codcliente);
            setTipoCliente(response.data.tipocliente)
            setNome(response.data.nome);
            setCPF(response.data.cpf);
            setRazaoSocial(response.data.razaosocial);
            setNomeFantasia(response.data.nomefantasia);
            setCNPJ(response.data.cnpj);
            setIE(response.data.ie);
            setCEP(response.data.cep);
            setEndereco(response.data.endereco);
            setNumero(response.data.numero);
            setComplemento(response.data.complemento);
            setBairro(response.data.bairro);
            setCidade(response.data.cidade);
            setUF(response.data.uf);
            setCodCidade(response.data.codcidade);
            setPais(response.data.pais);
            setCodPais(response.data.codpais);
            setTelefone(response.data.telefone);
            setWhatsApp(response.data.whatsapp);
            setEmail(response.data.email);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("v1/cad/cliente", {
                params: {
                    codcliente,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setshowform(true);
        setnovo(true);

        setCodCliente(0);
        setTipoCliente('F')
        setNome('');
        setCPF('');
        setRazaoSocial('');
        setNomeFantasia('');
        setCNPJ('');
        setIE('');
        setCEP('');
        setEndereco('');
        setNumero('');
        setComplemento('');
        setBairro('');
        setCidade('');
        setUF('');
        setCodCidade('');
        setPais('Brasil');
        setCodPais('1058');
        setTelefone('');
        setWhatsApp('');
        setEmail('');
    };

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    async function Editar() {
        try {
            setLoading(true);
            setError(null);
            await api.put("v1/cad/cliente", {
                tipocliente,
                nome,
                cpf,
                razaosocial,
                nomefantasia,
                cnpj,
                ie,
                cep,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                codcidade,
                pais,
                codpais,
                telefone,
                whatsapp,
                email,
                codcliente
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function Cadastrar() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            if (tipocliente === 'F') {
                if (!validarCPF(cpf)) {
                    toast.error("CPF inválido ❌");
                    return;
                }
            }

            await api.post("v1/cad/cliente", {
                tipocliente,
                nome,
                cpf,
                razaosocial,
                nomefantasia,
                cnpj,
                ie,
                cep,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                codcidade,
                pais,
                codpais,
                telefone,
                whatsapp,
                email,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    const consultarCep = async () => {
        try {
            const cepLimpo = cep.replace(/\D/g, "");
            if (cepLimpo.length !== 8) {
                alert("CEP inválido!");
                return;
            }

            const { data } = await api.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

            if (data.erro) {
                alert("CEP não encontrado!");
                return;
            }

            setEndereco(data.logradouro);
            setComplemento(data.complemento);
            setBairro(data.bairro);
            setCidade(data.localidade);
            setUF(data.uf);
            setCodCidade(data.ibge)
        } catch (error) {
            console.error("Erro ao consultar CEP:", error);
            alert("Não foi possível buscar o CEP.");
        }
    };

    const consultarCnpj = async () => {
        if (!cnpj || cnpj.length < 14) {
            alert("Informe um CNPJ válido!");
            return;
        }

        try {
            const { data } = await api.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj.replace(/\D/g, "")}`);


            setRazaoSocial(data.razao_social);
            setNomeFantasia(data.nome_fantasia);
            setIE(data.inscricao_estadual);
            setCEP(data.cep);
            setEndereco(data.logradouro);
            setNumero(data.numero);
            setBairro(data.bairro);
            setCidade(data.municipio);
            setUF(data.uf);


        } catch (error) {
            console.error(error);
            alert("Erro ao consultar CNPJ. Verifique se é válido.");
        }
    };

    function validarCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, '');

        if (cpf.length !== 11) return false;

        // Elimina CPFs inválidos conhecidos
        if (/^(\d)\1+$/.test(cpf)) return false;

        let soma = 0;
        let resto;

        // Primeiro dígito
        for (let i = 1; i <= 9; i++) {
            soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }

        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.substring(9, 10))) return false;

        // Segundo dígito
        soma = 0;
        for (let i = 1; i <= 10; i++) {
            soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
        }

        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;

        return resto === parseInt(cpf.substring(10, 11));
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <Modal
                        isOpen={showform}
                        onRequestClose={() => setshowform(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-group">
                                                <label className="form-label">Tipo de Cliente</label>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pessoaJuridica"
                                                        name="tipoFornecedor"
                                                        value="J"
                                                        checked={tipocliente === "J"}
                                                        onChange={(e) => setTipoCliente(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pessoaJuridica">
                                                        Pessoa Jurídica
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pessoaFisica"
                                                        name="tipoFornecedor"
                                                        value="F"
                                                        checked={tipocliente === "F"}
                                                        onChange={(e) => setTipoCliente(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pessoaFisica">
                                                        Pessoa Física
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        {tipocliente === 'J' ?
                                            (<>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="razaosocial"
                                                            value={razaosocial}
                                                            onChange={(e) => setRazaoSocial(e.target.value)}
                                                        />
                                                        <label htmlFor="razaosocial">Razão Social</label>
                                                    </div>
                                                </div>

                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="nomefantasia"
                                                            value={nomefantasia}
                                                            onChange={(e) => setNomeFantasia(e.target.value)}
                                                        />
                                                        <label htmlFor="nomefantasia">Nome Fantasia</label>
                                                    </div>
                                                </div>

                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating input-group">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name='cnpj'
                                                            id="CNPJ"
                                                            value={cnpj}
                                                            onChange={(e) => setCNPJ(e.target.value)}
                                                        />
                                                        <label htmlFor="cnpj">CNPJ</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            onClick={consultarCnpj}
                                                        >
                                                            <i className="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="ie"
                                                            value={ie}
                                                            onChange={(e) => setIE(e.target.value)}
                                                        />
                                                        <label htmlFor="ie">Ins. Estadual</label>
                                                    </div>
                                                </div>
                                            </>
                                            )
                                            :
                                            (<>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="nome"
                                                            value={nome}
                                                            onChange={(e) => setNome(e.target.value)}
                                                        />
                                                        <label htmlFor="nome">Nome</label>
                                                    </div>
                                                </div>
                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="cpf"
                                                            value={cpf}
                                                            onChange={(e) => setCPF(e.target.value)}
                                                        />
                                                        <label htmlFor="cpf">CPF</label>
                                                    </div>
                                                </div>
                                            </>)
                                        }
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating input-group">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cep"
                                                    id="cep"
                                                    value={cep}
                                                    onChange={(e) => setCEP(e.target.value)}
                                                />
                                                <label htmlFor="cep">CEP</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={consultarCep}
                                                >
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="endereco"
                                                    id="endereco"
                                                    value={endereco}
                                                    onChange={(e) => setEndereco(e.target.value)}
                                                />
                                                <label htmlFor="endereco">Endereço</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="numero"
                                                    id="numero"
                                                    value={numero}
                                                    onChange={(e) => setNumero(e.target.value)}
                                                />
                                                <label htmlFor="numero">Núm.</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="complemento"
                                                    id="complemento"
                                                    value={complemento}
                                                    onChange={(e) => setComplemento(e.target.value)}
                                                />
                                                <label htmlFor="complemento">Complemento</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="bairro"
                                                    id="bairro"
                                                    value={bairro}
                                                    onChange={(e) => setBairro(e.target.value)}
                                                />
                                                <label htmlFor="bairro">Bairro</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cidade"
                                                    id="cidade"
                                                    value={cidade}
                                                    onChange={(e) => setCidade(e.target.value)}
                                                />
                                                <label htmlFor="cidade">Cidade</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="uf"
                                                    id="uf"
                                                    value={uf}
                                                    onChange={(e) => setUF(e.target.value)}
                                                />
                                                <label htmlFor="uf">UF</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codcidade"
                                                    id="codcidade"
                                                    value={codcidade}
                                                    onChange={(e) => setCodCidade(e.target.value)}
                                                />
                                                <label htmlFor="codcidade">Cód. IBGE Cida.</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="pais"
                                                    id="pais"
                                                    value={pais}
                                                    onChange={(e) => setPais(e.target.value)}
                                                />
                                                <label htmlFor="pais">País</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codpais"
                                                    id="codpais"
                                                    value={codpais}
                                                    onChange={(e) => setCodPais(e.target.value)}
                                                />
                                                <label htmlFor="codpais">Cód. IBGE País</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="telefone"
                                                    id="telefone"
                                                    value={telefone}
                                                    onChange={(e) => setTelefone(e.target.value)}
                                                />
                                                <label htmlFor="telefone">Telefone</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="whatsapp"
                                                    id="whatsapp"
                                                    value={whatsapp}
                                                    onChange={(e) => setWhatsApp(e.target.value)}
                                                />
                                                <label htmlFor="whatsapp">WhatsApp</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="email"
                                                    id="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                                <label htmlFor="email">E-mail</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={Salvar}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </Modal>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Cadastro de Cliente" icon="user" />
                        <Description text="Cadastro dos clientes da empresa" />

                        <div className="row mb-3">
                            <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar cliente por: Código, Razão Social, CNPJ, Nome ou CPF"
                                />
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 text-center">
                                <AddButton onClick={handleAdd} text="Novo Cliente" disabled={!podeInserir("/cad/cliente")} />
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        onEdit={handleEdit}
                                        isEditDisabled={() => !podeEditar("/cad/cliente")}
                                        onDelete={handleOpen}
                                        isDeleteDisabled={() => !podeExcluir("/cad/cliente")}
                                    />
                                </div>
                            )}
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />
                    </div>
                </main>
            </div>
        </>
    );
};

export default CadCliente;